import ErrorCircleX from 'components/Icons/ErrorCircleX';
import SuccessCheck from 'components/Icons/SuccessCheck';
import BaseInput from 'components/inputs/BaseInput';
import React from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  isValid: boolean;
  tested?: boolean;
  showValidIcon: boolean;
  showInvalidIcon: boolean;
  onInputLoad?: (
    value: string | number | readonly string[] | undefined
  ) => void;
  autocomplete?: string;
}

class ValidatableInput extends React.Component<Props> {
  static defaultProps = {
    tested: true,
    showValidIcon: false,
    showInvalidIcon: false,
    autoComplete: 'on',
  };

  constructor(props: Props) {
    super(props);

    if (props.onInputLoad) {
      props.onInputLoad(props.defaultValue || props.value);
    }
  }

  render(): React.ReactNode {
    const {
      id,
      isValid,
      tested,
      showValidIcon,
      showInvalidIcon,
      // onInputLoad shouldn't be passed to an input element.
      onInputLoad: _onInputLoad, // eslint-disable-line
      style,
      ...rest
    } = this.props;

    let additionalStyles = style;

    if (tested) {
      if (!isValid) {
        additionalStyles = { ...style, borderColor: '#e32942' };
      }
    }

    return (
      <div id={id} className="pos-r">
        <BaseInput id={`${id}-input`} style={additionalStyles} {...rest} />
        {showValidIcon && isValid && tested ? (
          <div
            className="pos-a fill-success"
            style={{ top: '13px', right: '12px' }}
          >
            <SuccessCheck width="18px" height="18px" />
          </div>
        ) : null}
        {showInvalidIcon && !isValid && tested ? (
          <div
            className="pos-a fill-error"
            style={{ top: '13px', right: '12px' }}
          >
            <ErrorCircleX width="18px" height="18px" />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ValidatableInput;
